import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Modal, Spin } from "antd";
import "../styles/grader.css";

export default function Grader() {
  const problemRef = useRef(null);
  const [problems, setProblems] = useState(null);
  const [scores, setScores] = useState(null);
  const [uploadFile, setUploadFile] = useState(null);
  const [loadingID, setloadingID] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      await fetch(
        `${process.env.REACT_APP_API_URL}/api/problem`,
        {
          headers: new Headers({
            "x-access-token": localStorage.getItem("token"),
          }),
        }
      )
        .then((res) => res.json())
        .then(async (problem) => {
          setProblems(problem);

          const response = await fetch(
            `${process.env.REACT_APP_API_URL}/api/grader/` +
            localStorage.getItem("user_id"),
            {
              headers: new Headers({
                "x-access-token": localStorage.getItem("token"),
              }),
            }
          ).then((res) => res.json());

          let json = [],
            j = 0;
          for (let i = 0; i < problem.length; i++) {
            if (
              j < response.length &&
              response[j].problem_id === problem[i]._id
            ) {
              json.push({
                p1: response[j].p1,
                p2: response[j].p2,
                p3: response[j].p3,
                p4: response[j].p4,
                p5: response[j].p5,
                s1: response[j].s1,
                s2: response[j].s2,
                s3: response[j].s3,
                s4: response[j].s4,
                s5: response[j].s5,
                _id: response[j]._id,
                total: response[j].p1 + response[j].p2 + response[j].p3 + response[j].p4 + response[j].p5,
                problem_id: problem[i]._id,
                problem_name: problem[i].problem_name,
                user_id: localStorage.getItem("user_id"),
                index: i + 1,
              });
              j++;
            } else {
              json.push({
                p1: 0,
                p2: 0,
                p3: 0,
                p4: 0,
                p5: 0,
                s1: "-",
                s2: "-",
                s3: "-",
                s4: "-",
                s5: "-",
                problem_id: problem[i]._id,
                problem_name: problem[i].problem_name,
                user_id: localStorage.getItem("user_id"),
                index: i + 1,
                total: 0
              });
            }
          }
          setScores(json);
        });
    };
    fetchData();
  }, []);

  

  const handleChange = (e) => {
    setUploadFile(e.target.files[0]);
  };

  const showErrorModal = (message) => {
    Modal.error({
      title: "Error",
      content: message,
    });
  };

  const handleSubmit = async (e, problem_id, problem_name, scores_id, i) => {
    e.preventDefault();
    if (!uploadFile) {
      showErrorModal("Please select a file.");
      return;
    }
    const allowedExtensions = [".c", ".cpp"];
    const fileExtension = uploadFile.name.slice(uploadFile.name.lastIndexOf(".")).toLowerCase();
    if (!allowedExtensions.includes(fileExtension)) {
      showErrorModal("Invalid file format. Please upload a .c or .cpp file.");
      return;
    }
    
    setloadingID(problem_id);


    e.target[0]["value"] = null;
    const formData = new FormData();
    formData.append("code", uploadFile);
    formData.append("problem_id", problem_id);
    formData.append("problem_name", problem_name);
    formData.append("user_id", localStorage.getItem("user_id"));
    formData.append("index", i);
    e.target.value = null;

    await fetch(
      `${process.env.REACT_APP_API_URL}/api/grader/uploadCode`,
      {
        method: "POST",
        body: formData,
        headers: {
          "x-access-token": localStorage.getItem("token"),
        },
      }
    );

    formData.append("i", 1);
    let result_arr = [],
      score_arr = [];
    for (let i = 1; i <= 5; i++) {
      formData.set("i", i);
      let res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/grader/processCode`,
        {
          method: "POST",
          body: formData,
          headers: {
            "x-access-token": localStorage.getItem("token"),
          },
        }
      ).then((res) => {
        return res.json();
      });
      result_arr.push(res.result);
      score_arr.push(res.score);
    }

    const resultData = new FormData();
    resultData.append("s1", result_arr[0]);
    resultData.append("s2", result_arr[1]);
    resultData.append("s3", result_arr[2]);
    resultData.append("s4", result_arr[3]);
    resultData.append("s5", result_arr[4]);
    resultData.append("p1", score_arr[0]);
    resultData.append("p2", score_arr[1]);
    resultData.append("p3", score_arr[2]);
    resultData.append("p4", score_arr[3]);
    resultData.append("p5", score_arr[4]);
    resultData.append("problem_id", problem_id);
    resultData.append("problem_name", problem_name);
    resultData.append("user_id", localStorage.getItem("user_id"));
    resultData.append("index", i);

    await fetch(
      `${process.env.REACT_APP_API_URL}/api/grader/${problem_id}/${formData.get(
        "user_id"
      )}`,
      {
        method: "PUT",
        headers: {
          "x-access-token": localStorage.getItem("token"),
        },
        body: resultData,
      }
    );

    let newScore = [...scores];
    newScore[i - 1].p1 = score_arr[0];
    newScore[i - 1].p2 = score_arr[1];
    newScore[i - 1].p3 = score_arr[2];
    newScore[i - 1].p4 = score_arr[3];
    newScore[i - 1].p5 = score_arr[4];

    newScore[i - 1].s1 = result_arr[0];
    newScore[i - 1].s2 = result_arr[1];
    newScore[i - 1].s3 = result_arr[2];
    newScore[i - 1].s4 = result_arr[3];
    newScore[i - 1].s5 = result_arr[4];

    // Recalculate total score by summing the individual scores
    newScore[i - 1].total = score_arr.reduce((acc, score) => acc + score, 0);

    // Update the state with the new scores
    setScores(newScore);

    setloadingID(null);
    setUploadFile(null);
  };


  if (!scores || !problems) {
    return (
      <center>
        <Spin size="large" />
      </center>
    );
  }
  return (
    <div className="grader-container">
      {/* {
        visible && <Modal
          title="File Upload"
          open={visible}
          
          onOk={() => setVisible(false)}
          cancelButtonProps={{ style: { display: 'none' } }}
        >
          <p>{modalMessage}</p>
        </Modal>
        
      } */}

      {problems.map((problem, index) => (
        <div
          className="problem-card"
          key={problem._id}
          style={{
            opacity: loadingID === problem._id ? 0.5 : 1,
            pointerEvents: loadingID === problem._id ? "none" : "auto",
          }}
        >
          <div className="problem-header">
            <Link to={`/problem/${problem._id}`} className="problem-name">
              {index + 1}. {problem.problem_name}
            </Link>
            <span className="total-score">{scores[index].total} pts</span>
          </div>
          <table className="grader-table">
            <thead>
              <tr>
                <th colSpan="5">Results</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                {["s1", "s2", "s3", "s4", "s5"].map((key, i) => (
                  <td key={i} className={scores[index][key] === "P" ? "success" : "error"}>
                    {scores[index][key] === 'P' ? '✅' : scores[index][key] === 'T' ? '⏳' : '❌' || "-"}

                  </td>
                ))}
              </tr>
              <tr>
                {["p1", "p2", "p3", "p4", "p5"].map((key, i) => (
                  <td key={i}>{scores[index][key]}</td>
                ))}
              </tr>
            </tbody>
          </table>
          <form
            ref={problemRef}
            style={{ width: "100%" }}
            onSubmit={(e) =>
              handleSubmit(e,
                problem._id,
                problem.problem_name,
                scores[index]._id,
                index + 1)
            }
          >
            <input
              type="file"
              accept=".c, .cpp"
              onChange={handleChange}
              className="file-input"
            />
            <button className="submit-btn">Submit</button>
          </form>
        </div>
      ))}
    </div>
  );
}
